import {
  UserRoleInAudit,
  UserRoleInProject,
} from '@/store/modules/projects/types/projects.types';

export const getProjectUrlByRole = (
  projectId: number,
  userRoleInProject: UserRoleInProject,
) => {
  switch (userRoleInProject) {
    case UserRoleInProject.isOwner:
      return '/projects/' + projectId + '#dashboard';
    case UserRoleInProject.isProjectCoOrdinator:
      return '/projects/' + projectId + '#dashboard';
    case UserRoleInProject.isDataCollector:
      return '/projects/' + projectId + '/homepage';
    default:
      return '/projects/me';
  }
};

export const getAuditUrlByRole = (
  auditId: number,
  userRoleInAudit: UserRoleInAudit,
): string => {
  if (
    userRoleInAudit === UserRoleInAudit.isOwner ||
    userRoleInAudit === UserRoleInAudit.isProjectCoOrdinator
  ) {
    return '/audits/' + auditId + '#dashboard';
  } else {
    return '/audits/' + auditId + '/homepage#dataCollectionSheet';
  }
};
